import { render, staticRenderFns } from "./NewSubscriber1.vue?vue&type=template&id=0dd04254&scoped=true"
import script from "./NewSubscriber1.vue?vue&type=script&lang=js"
export * from "./NewSubscriber1.vue?vue&type=script&lang=js"
import style0 from "./NewSubscriber1.vue?vue&type=style&index=0&id=0dd04254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd04254",
  null
  
)

export default component.exports